module.exports = __webpack_public_path__ + "img/yw_1.9adc8f9a.png";